import { Link } from "react-router-dom";
import { footerGroups, siteConfig } from "@/config/site";
import { Logo } from "./Logo";
import "./SiteFooter.css";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <div className="site-footer-brand">
          <Logo />
          <p>{siteConfig.tagline}</p>
          <p className="site-footer-copyright">
            © {new Date().getFullYear()} {siteConfig.legalDeveloper}. Devory is a product of{" "}
            {siteConfig.legalDeveloper}.
          </p>
        </div>
        <nav className="site-footer-groups" aria-label="Footer">
          {footerGroups.map((group) => (
            <div key={group.heading} className="site-footer-group">
              <h2>{group.heading}</h2>
              <ul>
                {group.links.map((link) => (
                  <li key={link.path}>
                    {link.path.startsWith("http") ? (
                      <a href={link.path}>{link.label}</a>
                    ) : (
                      <Link to={link.path}>{link.label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>
    </footer>
  );
}
